module.exports = __webpack_public_path__ + "static/media/tapeYeast2.b0c26350.jpg";